import { apiGet, apiPut, apiPutBinary } from "./client";
import type { Profile } from "@sales-ops-amplify/shared";
import type { ProfilePatch } from "@/types";

/** Fetch the user's profile. */
export async function getProfile(): Promise<Profile> {
  const res = await apiGet<{ profile: Profile | null }>("/api/profile");
  return (res.profile ?? {}) as Profile;
}

/** Partial update to the profile. */
export async function updateProfile(patch: ProfilePatch): Promise<Profile> {
  const res = await apiPut<{ profile: Profile }>("/api/profile", patch);
  return res.profile;
}

/** Upload a validated profile image to the current user's private S3 prefix. */
export async function uploadProfilePicture(file: File): Promise<Profile> {
  const res = await apiPutBinary<{ profile: Profile }>("/api/profile/picture", file);
  return res.profile;
}
